import { useTenantConfig } from '../../../hooks/use-tenant-config';
import { PortalLoading } from '../PortalShell';
import { HistorialPage } from './HistorialPage';
import { PortalRecordPage } from './PortalRecordPage';
import { historialView } from './portal-record.model';

/** «Historial»: el expediente con `graduation_audit`; sin él, la página de siempre. */
export function HistorialRoute(): JSX.Element {
  const config = useTenantConfig();
  const view = historialView({
    settled: config.settled,
    credentialRecord: config.academicRecord.mode === 'credentials',
  });
  if (view === 'loading') return <PortalLoading />;
  return view === 'record' ? <PortalRecordPage /> : <HistorialPage />;
}
